import React from 'react';
import './App.css';
import NavBar from './Components/navbar';

function App() {
  return (
    <div className="App">

      <NavBar />

    </div>
  );
}

export default App;